import { NextArrow, PrevArrow  } from "../Arrows";
import Slider from 'react-slick';

function Teastimonial({ testimonial }) {


   const testimonialSlider = {
        dots: false,
        infinite: true,
        speed: 1000,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        adaptiveHeight: false,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        draggable: false,
        swipe: true,
        touchMove: true,
       responsive: [
            {
                breakpoint: 991,
                settings: { slidesToShow: 2, }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1, }
            }
        ]
    };
  return (
    <>
      <div className="testimonial-section2 mb-100" data-aos="fade-up">
        <div className="testimonial-slider">
          <div className="container">
            <div className="section-title2 primary3 text-start">
              <span>{testimonial.main_title}</span>
                <h2>{testimonial.highlist_title}</h2>
            </div>
            <div className="position-relative testimoanial-items">

              <Slider {...testimonialSlider}>
                {
                  testimonial.testimonial_list.map((info, index) => (
                    <div key={index}>
                      <div className="testimonial-wrap" >
                        <div className="testimonial-single2 glass-effect">
                          <p className="para">
                            {info.short_description}
                          </p>
                          <div className="author">
                            <div className="author-img">
                              <img src={info.image} alt="webco" />
                            </div>
                            <div className="author-desig">
                              <h2>{info.customer_name}</h2>
                              <p>{info.designation}</p>
                            </div>
                          </div>



                        </div>
                      </div>
                    </div>
                  ))
                }
              </Slider>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Teastimonial;
